import React, { useEffect, useMemo, useRef, useState } from "react";
import { Dropdown } from "react-bootstrap";
import "./Notifications.css";
import axios from "axios";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { dateTime } from "../../Features/dateTime";
import { FiBell, FiInbox, FiArrowRight, FiCircle } from "react-icons/fi";
import NotificationImageModal from "./NotificationImageModal";
import customloader from "../../assets/images/RollingLoader.gif";
import useNotificationAction from "../../Hooks/useNotificationAction";
const NotificationDropdown = ({ show, handleClose }) => {
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  const { user } = useSelector((state) => state.auth);
  const notification = useSelector((state) => state.notification);
  const [notifications, setNotifications] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { handleNotificationStatus, imageModal, data, closeImageModal } = useNotificationAction();
  const handleClick = () => {
    handleClose();
    navigate("/notifications");
  };
  useEffect(() => {
    setIsLoading(true);
    axios
      .get(process.env.REACT_APP_API_URL + `/notifications/?user_id=${user.user_id}`, {
        withCredentials: true,
      })
      .then((data) => {
        setNotifications(data.data.data?.data);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        const tempErr = err.response.data.error;
        if (tempErr.status === 404 && tempErr.message === "No Record Found") {
          setNotifications([]);
        }
      });
  }, [show]);

  const datetimeFunction = (value) => {
    const dateFormat = dateTime(value);
    return dateFormat.toLocaleDateString("en-US", { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
  };
  const unreadCount = +notification.notificationsCount > 99 ? "99+" : notification.notificationsCount;

  const listOfClasses = useMemo(() => ["notificationButton", "notif-image-modal-link-btn", "notif-image-modal-img", "btn-close", "modal-title", "modal-header", "modal-footer"], []);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        if (!listOfClasses.some((c) => event.target.classList.contains(c))) {
          handleClose();
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <>
      <Dropdown show={show} align="end" ref={dropdownRef}>
        <Dropdown.Menu className="border-0 shadow mt-1 notif-dropdown">
          <div className="notif-dropdown-header">
            <h6 className="notif-dropdown-title">Notifications</h6>
            {unreadCount > 0 && <span className="notif-dropdown-badge">{unreadCount}</span>}
          </div>
          {isLoading ? (
            <div className="notif-loading">
              <img src={customloader} alt="loader" width="60" height="60" />
            </div>
          ) : notifications.length === 0 ? (
            <div className="notif-empty">
              <div className="notif-empty-icon">
                <FiInbox />
              </div>
              <p className="notif-empty-title">No notifications yet</p>
              <p className="notif-empty-subtitle">You'll see notifications here when they arrive</p>
            </div>
          ) : (
            <div className="notif-dropdown-list">
              {notifications?.map((item, index) => (
                <div
                  key={`notif-${item.id || index}`}
                  className={`notif-dropdown-item ${item.is_read === 0 ? "notif-dropdown-item-unread" : ""}`}
                  onClick={() => handleNotificationStatus(item, handleClose)}
                >
                  <div className={`notif-card-icon ${item.is_read === 0 ? "notif-card-icon-unread" : "notif-card-icon-read"}`}>
                    <FiBell />
                  </div>
                  <div className="notif-card-body">
                    <p className="notif-card-title">{item.title}</p>
                    <p className="notif-card-text">{item?.body}</p>
                    <p className="notif-card-time">{datetimeFunction(item?.created_at)}</p>
                  </div>
                  {item?.is_read === 0 && <FiCircle className="notif-card-dot" size={8} fill="#8834ff" />}
                </div>
              ))}
            </div>
          )}
          <div className="notif-dropdown-footer">
            <span className="notif-dropdown-footer-link" onClick={handleClick}>
              See All <FiArrowRight size={12} style={{ verticalAlign: "middle" }} />
            </span>
          </div>
        </Dropdown.Menu>
      </Dropdown>
      <NotificationImageModal
        show={imageModal}
        close={closeImageModal}
        data={data}
      />
    </>
  );
};

export default NotificationDropdown;
